var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dividePage" }, [
    _c(
      "div",
      { staticClass: "wrap" },
      [
        _c(
          "van-radio-group",
          {
            model: {
              value: _vm.radioCheck,
              callback: function($$v) {
                _vm.radioCheck = $$v
              },
              expression: "radioCheck"
            }
          },
          [
            _c(
              "div",
              { staticClass: "divide-row" },
              [
                _c("span", [_vm._v("红利再投资")]),
                _c("van-radio", {
                  attrs: {
                    name: "0",
                    "checked-color": "#E12817",
                    "icon-size": "18px"
                  }
                })
              ],
              1
            ),
            _c("p", { staticClass: "introduce" }, [
              _vm._v(" 收益分配用于追加投资。 ")
            ]),
            _c("div", { staticClass: "line" }),
            _c(
              "div",
              { staticClass: "divide-row" },
              [
                _c("span", [_vm._v("现金分红")]),
                _c("van-radio", {
                  attrs: {
                    name: "1",
                    "checked-color": "#E12817",
                    "icon-size": "18px"
                  }
                })
              ],
              1
            ),
            _c("p", { staticClass: "introduce" }, [
              _vm._v("收益分配采用现金方式。")
            ]),
            _c("div", {
              staticClass: "line",
              staticStyle: { "margin-bottom": "0.08rem" }
            }),
            _vm.$route.query.dividendMethod == "1"
              ? _c("div", { staticClass: "divide-choose-tip" }, [
                  _vm._v("当前分红方式：现金分红")
                ])
              : _c("div", { staticClass: "divide-choose-tip" }, [
                  _vm._v("当前分红方式：红利再投资")
                ]),
            _c("div", { staticClass: "tip" }, [
              _c("p", [
                _vm._v("1、设置分红方式的受理结果以份额登记机构确认为准。")
              ]),
              _c("p", [
                _vm._v("2、交易日15时后的变更，将作为下一交易日申请。 ")
              ]),
              _c("p", [_vm._v("3、同一交易日内多次提交以最后一次为准。")])
            ])
          ]
        ),
        _vm.dividendModeArr.length > 0
          ? _c(
              "div",
              { staticClass: "divide-list-top", on: { click: _vm.moreClick } },
              [
                _c("p", [_vm._v("分红方式变更记录")]),
                _c("van-icon", {
                  staticClass: "customIcon",
                  attrs: { name: "arrow" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.dividendModeArr.length > 0
          ? _c("div", { staticClass: "tableHeader" }, [
              _c("div", { staticClass: "tabListItem header-grey width18" }, [
                _vm._v("原分红方式")
              ]),
              _c("div", { staticClass: "tabListItem header-grey width28" }, [
                _vm._v("变更后分红方式")
              ]),
              _c("div", { staticClass: "tabListItem width17 header-grey" }, [
                _vm._v("申请时间")
              ]),
              _c("div", { staticClass: "tabListItem width17 header-grey" }, [
                _vm._v("变更渠道")
              ]),
              _c("div", { staticClass: "tabListItem width17 header-grey" }, [
                _vm._v("确认状态")
              ])
            ])
          : _vm._e(),
        _vm._l(_vm.dividendModeArr, function(item) {
          return _c("div", [
            _c("div", { staticClass: "divider" }),
            _c("div", { staticClass: "list" }, [
              _c("p", { staticClass: "tabListItem width18" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.transDividendMethod(item.currentDividendMethod)
                    ) +
                    " "
                )
              ]),
              _c("p", { staticClass: "tabListItem width28" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.transDividendMethod(item.changeDividendMethod)) +
                    " "
                )
              ]),
              _c("p", { staticClass: "tabListItem width17" }, [
                _vm._v(_vm._s(item.appointmentDate))
              ]),
              _c("p", { staticClass: "tabListItem width17" }, [
                _vm._v(_vm._s(_vm.transSource(item.orderSource)))
              ]),
              item.confirmStatus == "10"
                ? _c("p", { staticClass: "tabListItem red width17" }, [
                    _vm._v("待确认")
                  ])
                : item.confirmStatus == "30"
                ? _c("p", { staticClass: "tabListItem green width17" }, [
                    _vm._v(" 确认失败 ")
                  ])
                : _c("p", { staticClass: "tabListItem green width17" }, [
                    _vm._v("已确认")
                  ])
            ])
          ])
        })
      ],
      2
    ),
    _c("div", { staticClass: "bottom" }, [
      _c(
        "div",
        { staticClass: "comfirm-btn", on: { click: _vm.comfirmClick } },
        [_vm._v("确定")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }